const FREESPEE_ENDPOINT = '/rest/{adId}/number/ad';
const CRITEO_TRACKING_ENDPOINT = '/api/v1/trackings/criteo/posts/{adId}/phone';

export default class FreespeeDynamicAd {

    /**
     * @param element
     * @param gtm
     * @param w
     */
    constructor(element, gtm, w) {
        this.window = w || window;
        this.$element = $(element);
        this.gtm = gtm;
        this.adId = this.$element.data('freespee-dynamic-ad');
        this.extraparam = this.$element.data('extraparam');
        this.$textElement = this.$element.find('[data-text-phone-number]');
        this.checkViewport = this.$element.data('freespee-check-viewport') || false;
        this.breakpoint = 767;
        this.csrfToken = $('meta[name="_csrf"]').attr('content');
        this.setup();
    }

    setup() {
        this.$element.off('click').on('click', (event) => {
            if(!this.$element.data('freespee-link').startsWith('tel:')) {
                $.ajax({
                    url: FREESPEE_ENDPOINT.replace('{adId}', this.adId),
                    type: 'POST',
                    headers: {
                        'X-CSRF-Token': this.csrfToken
                    },
                    success: (data) => {
                        if (this.quickCall()) {
                            window.location.href = 'tel:' + data.number;
                            this.gtm.trackEvent('R2SPhoneBegin', this.extraparam);
                        } else {
                            if (!this.$element.data('freespee-link').startsWith('tel:')) {
                                this.gtm.trackEvent('R2SPhoneBegin', this.extraparam);
                                this.$textElement.text(data.number);
                                this.$element.data('freespee-link', 'tel:' + data.number);
                            }
                        }
                        var url = new URL(window.location.href);
                        this.trackPhoneCall(this.adId, url);
                    }
                });
            } else {
                window.location.href = this.$element.data('freespee-link');
            }
        });
    }

    quickCall() {
        return !!(this.checkViewport && window.matchMedia(`(max-width: ${this.breakpoint}px)`).matches);
    }

    trackPhoneCall(adId, url) {
        var criteoTrackingUrl = CRITEO_TRACKING_ENDPOINT.replace('{adId}', adId);
        var utmSource = url.searchParams.get('utm_source');
        if (utmSource !== null) {
            criteoTrackingUrl += '?utm_source=criteo';
        }

        $.ajax({
            url: criteoTrackingUrl,
            type: 'GET',
            success: function(data) {
                window.criteo_q = window.criteo_q || [];
                window.criteo_q.push.apply(window.criteo_q, data.events);
            },
            error: function(request, status, error) {
                console.error('An error occurred while publishing Criteo event');
            }
        });

        //RTB TRACKING

        var gdprConsentFromLocal = localStorage.getItem('gdprConsent');

        if (gdprConsentFromLocal !== null) {
            var gdprConsent = JSON.parse(gdprConsentFromLocal);

            let consentedToEverything = typeof gdprConsent.isConsentedToEverything === 'boolean' && gdprConsent.isConsentedToEverything;

            if (consentedToEverything) {
                let typeOrderId = 'showNumberVIP-' + Date.now();
                let priceValue = ~~window._store.ads.customParams.price_value;

                let iframeRTB = document.createElement('iframe');
                iframeRTB.setAttribute('src', `https://creativecdn.com/tags?id=pr_zXB5EYQbuoe7g4Bx0m8A_orderstatus2_${priceValue}_${typeOrderId}_${adId}&amp;cd=default`);
                iframeRTB.style.width = '1px';
                iframeRTB.style.height = '1px';
                iframeRTB.style.display = 'none';
                iframeRTB.setAttribute('scrolling', 'no');
                iframeRTB.setAttribute('frameborder', '0');
                
                document.body.appendChild(iframeRTB);
            }

        }



    }

}
